module.exports = __webpack_public_path__ + "static/media/mesh basket.15.ed2c5add.png";